<template>
    <button class="arrow" v-bind:class="direction">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20px" height="20px" viewBox="0 0 35 60" xml:space="preserve">
            <polyline v-bind:class="color" fill="none" stroke-width="20" stroke-linecap="round" stroke-linejoin="round" points="0.375,0.375 45.63,38.087 0.375,75.8 "/>
        </svg>
    </button>
</template>

<script>
export default {
  name: 'arrow-button',
  props: ['direction', 'color'],
};
</script>

<style lang="scss" scoped>
    button.arrow {
        cursor: pointer;
        top: 93%;
        width: 35px;
        height: 35px;
        border: 3px solid $c--black;
        border-radius: 20px;
        transform: rotate(90deg);
        stroke: $c--black;
        transition: all 150ms ease-in-out;
        stroke-width: 10;

        svg{
            padding: 5px;
            overflow: visible;
        }

        polyline {
            transition: all 150ms ease-in-out;
            stroke: $c--black;
        }

        &:hover{
            border-color: $color--brand-primary;
            transition: all 150ms ease-in-out;

            polyline{
                stroke: $color--brand-primary;

                &.primary{
                    stroke: $color--brand-primary;
                }

                &.secondary{
                    stroke: $color--brand-secondary
                }
            }
        }

        &.left{
            transform: rotate(180deg);
        }

        &.right{
            transform: rotate(0deg);
        }

        @include mq('phablet', 'max') {
            display: none;
        }

        @include mqlandscape(){
            display: none;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/shared/ArrowButton.vue